import { useQuery } from "@tanstack/react-query";
import apiClient, { BASE_URL } from "@apis/index";
import { ProductCategory } from "@utils/constants";

export const useSearchFiltersData = (
  enabled: boolean,
  endpoint: string,
  server_side_search: boolean,
  input?: string,
  queryKey?: string,
  productType?: ProductCategory,
  name?: string,
  vdbSetting?: boolean,
  groupIds?: number[]
) => {
  const baseUrl = `${BASE_URL}v3/${endpoint}`;
  const { data, isSuccess, isFetching } = useQuery({
    queryKey: ["GET_SEARCH_FILTERS_PAYLOAD", endpoint, input],
    enabled,
    cacheTime: server_side_search ? 0 : 86400000,
    staleTime: server_side_search ? 0 : 86400000,
    queryFn: () => {
      const params = {
        [queryKey || "term"]: name === "Origin" ? undefined : input || "",
        lab_grown: productType === ProductCategory.LAB_GROWN_DIAMOND,
        fetch_type:
          name === "Origin" || name === "Supplier" ? productType : undefined,
        ...(vdbSetting ? { vdb_setting: vdbSetting } : {}),
        ...(!vdbSetting ? { group_ids: groupIds } : {}),
      };

      return apiClient.get(baseUrl, {
        baseURL: "",
        params,
      });
    },
    onError: (err) => {
      console.log("err", err);
    },
  });

  return { data: data?.data, isFetching, isSuccess };
};
